/**
 * Web Worker: https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
 * Runs in background, helps inprove performance of the page
 */
function initiateFetchWorker() {
    onmessage = function(e) {
        fetch(e.data[0])
            .then((res) => res.json())
            .then((res) => {
                if(res && res.modules) {
                    postMessage(res);
                }
            })
            .catch((_error) => {
            });
    }
}
module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.placementId,
            module: input.module,
            skeletonId: `skeleton${input.placementId}`,
            content: undefined,
        };
    }

    /**
     * 
     * @param {modules} response 
     * Renders response from napkin on the page
     * renderReady(): => looks at loading parameter to decide when to render the content
     * render(): => initate step-by-step process 
     *              - Sync CSS -> Sync [HTML + inline CSS] -> Sync JS -> Async Inline JS -> Async Scripts inside HTML -> Async activate_mod_merch
     */
    renderContent(response) {
        const { placementId, skeletonId } = this.state;
        if (response.modules[`PLACEMENT_${placementId}`]) {
            const module = response.modules[`PLACEMENT_${placementId}`];
            // if module is empty, remove skeleton
            if(Object.keys(module).length === 0) {
                document.getElementById(skeletonId).style.display = 'none';
            } else {
                // eliminates the case where CACHE_MODULE's response is another CACHE_MODULE or it is not HTML_MODULE
                this.state.content = {placementId: placementId, module: module, options: { skeletonId: skeletonId } };
            }
        } else {
            document.getElementById(skeletonId).style.display = 'none';
        }
    }

    /**
     * 
     * @param {Napkin URL} cacheURL 
     * if data is already available, start rendering
     * else, set a listener
     *      -   When data arrive, start rendering
     *      -   remove the listener ({once: true})
     */
    attachListener(cacheURL) {
        if (window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url && cacheMeta.url === cacheURL && cacheMeta.modules)) {
            this.renderContent(window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules);
        } else {
            document.addEventListener(`nutsCacheResponse:${cacheURL}`, ()  =>{
                this.renderContent(window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules);
            }, { once: true });
        }
    }

    /**
     * 
     * @param {Napkin URL} cacheURL 
     * Checks if a url is currently queued for processing
     *      - if no:    -   Add url to the global object (window.ebay.ads.cache[].url)
     *                          ex:     window.ebay.ads.cache: [{
     *                                      url: 'https://napkin/1"
     *                                  }];
     *                  -   initate a worker (which fetch the url)
     *                  -   on content received, it is stored as an global object
     *                          ex:     window.ebay.ads.cache: [{
     *                                      url: 'https://napkin/1"
     *                                      modules: {...}
     *                                  }];
     */
    startFetchWork(cacheURL) {
        if(!window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url && cacheMeta.url === cacheURL)) {
            window.ebay.ads.cache.push({
                url: cacheURL
            });
            const fetchWorker = new Worker(URL.createObjectURL(new Blob(["("+initiateFetchWorker.toString()+")()"], {type: 'text/javascript'})));
            fetchWorker.postMessage([cacheURL]);
            fetchWorker.onmessage = function(e) {
                const modules = e.data;
                window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules = modules;
                document.dispatchEvent(new Event(`nutsCacheResponse:${cacheURL}`));
            }
        }
    }

    /**
     * sets up window.ebay.ads.cache = [];
     * We don't want to destroy other global objects, Hence a safer way of creating the desired object
     */
    setWindowEbayAdsCache() {
        if(window.ebay) {
            if(window.ebay.ads) {
                if(!window.ebay.ads.cache) {
                    window.ebay.ads.cache = [];
                }
            } else {
                window.ebay.ads = {
                    cache: []
                };
            }
        } else {
            window.ebay = {
                ads: {
                    cache: []
                }
            };
        }
    }

    /**
     * Gets called automatically, as soon as the content is loaded on browser
     * Executes in browser (Window, document) object are available in this function
     */
    onMount() {
        const { module, skeletonId } = this.state;
        // Before any of the module is looked for processing. We should have url in the modules
        if(module && module.cache && module.cache.url) {
            const cacheURL = module.cache.url;
            this.setWindowEbayAdsCache();
            // for each url, go to napkin and get content (Function is only proceesed for unqiue url's)
            this.startFetchWork(cacheURL);
            // for each placement wait for content and then render
            this.attachListener(cacheURL);
        }
    }
};
